module.exports = __webpack_public_path__ + "5a2eba3ba4373054a4f4c826105e9998.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/hand/sandwich.png
// module id = 2109
// module chunks = 0